import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { CheckCircle, XCircle } from 'lucide-react';
export function QualificationSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-stone-950" data-id="element-4156">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 30
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-5xl mx-auto" data-id="element-4157">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-center text-stone-100 mb-12 sm:mb-16" style={{
        fontFamily: 'Cinzel, serif'
      }} data-id="element-4158">
          Is This Right For You?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12" data-id="element-4159">
          {/* Who this is for */}
          <div data-id="element-4160">
            <h3 className="text-xl sm:text-2xl font-bold text-green-400 mb-6 flex items-center gap-3" data-id="element-4161">
              <CheckCircle className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-4162" />
              This IS For You If:
            </h3>
            <ul className="space-y-4 sm:space-y-6" data-id="element-4163">
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4164">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4165" />
                <span data-id="element-4166">
                  You are a medical professional, coach, or serious biohacker
                  who wants to operate at the cutting edge.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4167">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4168" />
                <span data-id="element-4169">
                  You understand that true mastery requires deep study and
                  ongoing education.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4170">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4171" />
                <span data-id="element-4172">
                  You want to be able to solve complex health puzzles that leave
                  others stumped.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4173">
                <div className="w-1.5 h-1.5 bg-green-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4174" />
                <span data-id="element-4175">
                  You value scientific validation and evidence-based protocols
                  over hype.
                </span>
              </li>
            </ul>
          </div>

          {/* Who this is NOT for */}
          <div data-id="element-4176">
            <h3 className="text-xl sm:text-2xl font-bold text-red-400 mb-6 flex items-center gap-3" data-id="element-4177">
              <XCircle className="w-6 h-6 sm:w-8 sm:h-8" data-id="element-4178" />
              This Is NOT For You If:
            </h3>
            <ul className="space-y-4 sm:space-y-6" data-id="element-4179">
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4180">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4181" />
                <span data-id="element-4182">
                  You are looking for a "magic pill" that requires no effort or
                  understanding.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4183">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4184" />
                <span data-id="element-4185">
                  You are not willing to invest time in learning the
                  foundational principles.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4186">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4187" />
                <span data-id="element-4188">
                  You are satisfied with mainstream, surface-level health
                  advice.
                </span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-base sm:text-lg" data-id="element-4189">
                <div className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2.5 flex-shrink-0" data-id="element-4190" />
                <span data-id="element-4191">
                  You want quick hacks rather than deep, sustainable biological
                  optimization.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </motion.div>
    </section>;
}